import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'kb-price-range-inputs',
    templateUrl: './price-range-inputs.component.html',
    styleUrls: ['./price-range-inputs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgClass,
    ],
})
export class PriceRangeInputsComponent implements OnChanges {
    @Input() min: number | undefined;
    @Input() max: number | undefined;
    @Output() rangeChange = new EventEmitter<{ min?: number; max?: number }>();
    minControl = new UntypedFormControl();
    maxControl = new UntypedFormControl();

    ngOnChanges(changes: SimpleChanges) {
        if (changes.min?.currentValue == null) {
            this.minControl.setValue(undefined);
        }
        if (Number.isInteger(changes.min?.currentValue)) {
            this.minControl.setValue(changes.min.currentValue / 100);
        }
        if (changes.max?.currentValue == null) {
            this.maxControl.setValue(undefined);
        }
        if (Number.isInteger(changes.max?.currentValue)) {
            this.maxControl.setValue(changes.max.currentValue / 100);
        }
    }

    apply() {
        const min = this.minControl.value ? this.minControl.value * 100 : undefined;
        const max = this.maxControl.value ? this.maxControl.value * 100 : undefined;
        this.rangeChange.emit({ min, max });
        this.minControl.markAsPristine();
        this.maxControl.markAsPristine();
    }
}
